import React, { useState, useContext, useEffect } from "react";
import Input from "../input/Input";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../stores/Context/Context";
import { language } from "../../stores/slices/languageSlice";
import validateInput from "../../utilities/validations/validateInput";
import { toast } from "react-toastify";
import DateInput from "../input/Date";
import { smartyStreetApi } from "../../stores/slices/smartyStreetSlice";
import { lookUp } from "../../stores/slices/lookupSlice";
import { personalInfoData } from "../../stores/slices/patientSearch/patientSearchSlice";

function PersonalInfo() {
  let wizardValidation = useContext(UserContext);
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(language).Appintake.personalInformation;
  const isPDMI = useSelector(
    (state) => state.preQualValidateSlice.success.appIntakeSteps.isPDMI
  );
  const preQualData = useSelector((state) => state.preQualValidateSlice.success.preQualData)
  const patientInformation = useSelector(
    (state) => state.patientSearchSlice.patientInformation
  );
  const appIntakeSteps = useSelector(state => state.preQualValidateSlice.success.appIntakeSteps)
  const isEPaymentAvailable = useSelector(
    (state) =>
      state.preQualValidateSlice.success.personalInfo.isEPaymentAvailable
  );
  const applicantData = useSelector(state => state.loginSlice)
  const errorMessage = useSelector(language).errorMessage;
  const lookUpData = useSelector(lookUp);
  const [personalInfo, setPersonalInfo] = useState({
    addressType: { value: "", isValid: true },
    addressLine1: { value: "", isValid: true },
    addressLine2: { value: "", isValid: true },
    city: { value: "", isValid: true },
    state: { value: "", isValid: true },
    zipcode: { value: "", isValid: true },
    contactby: { value: "", isValid: true },
    preferedLanguage: { value: "", isValid: true },
    email: { value: "", isValid: true },
    emailType: { value: "", isValid: true },
    emailOwner: { value: "", isValid: true },
    phoneType: { value: "", isValid: true },
    phoneNumber: { value: "", isValid: true, errorMsg: false },
    contactSequence: { value: "", isValid: true },
    hasGuardian: false,
    guardianFirstName: { value: "", isValid: true },
    guardianLastName: { value: "", isValid: true },
    guardianSuffix: { value: "", isValid: true },
    guardianDOB: { value: "", isValid: true },
    guardianSSN: { value: "", isValid: true },
    guardianAlien: { value: "", isValid: true },
    guardianRelationshipToPatient: { value: "", isValid: true },
    guardianEmployment: { value: "", isValid: true },
    guardianEmail: { value: "", isValid: true },
    guardianEmailType: { value: "", isValid: true },
    guardianAddressLine1: { value: "", isValid: true },
    guardianAddressLine2: { value: "", isValid: true },
    guardianCity: { value: "", isValid: true },
    guardianState: { value: "", isValid: true },
    guardianZipcode: { value: "", isValid: true },
    isGuardianAddressVerified: false,
    guardianPhoneType: { value: "", isValid: true },
    guardianPhoneNumber: { value: "", isValid: true, errorMsg: false },
    gender: { value: "", isValid: true },
    employementStatus: { value: "", isValid: true },
    veteran: { value: "", isValid: true },
    maritalStatus: { value: "", isValid: true },
    householdSize: { value: "", isValid: true },
    origin: { value: "", isValid: true },
    relationshipToPatient: { value: "", isValid: true },
    applicantFirstName: { value: "", isValid: true },
    applicantLastName: { value: "", isValid: true },
    applicantPhoneNumber: { value: "", isValid: true, errorMsg: false },
    referredBy: { value: "", isValid: true },
    race: [],
    raceLookUp: [],
    copayPrograms: { value: "", isValid: true, isChecked: false },
    raceOther: { value: "", isValid: true },
    referredOther: { value: "", isValid: true },
    healthCareProfessionalFirstName: { value: "", isValid: true },
    healthCareProfessionalLastName: { value: "", isValid: true },
    healthCareProfessionalFacilityName: { value: "", isValid: true },
    healthCareProfessionalPosition: { value: "", isValid: true },
    healthCareFacilityName: { value: "", isValid: true },
    healthCareAddressLine1: { value: "", isValid: true },
    healthCareAddressLine2: { value: "", isValid: true },
    healthCareCity: { value: "", isValid: true },
    healthCareState: { value: "", isValid: true },
    healthCareZipcode: { value: "", isValid: true },
    healthCarePhoneNumber: { value: "", isValid: true, errorMsg: false },
    healthCareEmail: { value: "", isValid: true },
    healthCareEmailType: { value: "", isValid: true },
    PayableToFirstName: {
      value: '',
      isValid: true,
      required: true,
    },
    PayableToLastName: {
      value: '',
      isValid: true,
      required: true,
    },
    PayableAddressLine1: {
      value: '',
      isValid: true,
      required: true,
    },
    PayableAddressLine2: {
      value: '',
      isValid: true,
      required: true,
    },
    PayableCity: {
      value: '',
      isValid: true,
      required: true,
    },
    PayableState: {
      value: '',
      isValid: true,
      required: true,
    },
    PayableZipCode: {
      value: '',
      isValid: true,
      required: true,
    },
    isPayableAddressVerified:false,
    payable:{
    smartyStreetMatches:{
        NoMatch: false,
        PartialMatch: false,
        SecInfoNotMatch: false,
        ExactMatch: false,
      },
      ss_msg:"",
      ss_msg_cls: "",
    },
    sameAsHealthCare: false,
    isPhoneNumberChecked: true,
    isAddressChecked: true,
    isHealthCareAddressVerified: false,
    guardian: {
      isVerified: false,
      smartyStreetMatches: {
        NoMatch: false,
        PartialMatch: false,
        SecInfoNotMatch: false,
        ExactMatch: false,
      },
      ss_msg_cls: "",
      ss_msg: "",
    },
    healthCare: {
      isVerified: false,
      smartyStreetMatches: {
        NoMatch: false,
        PartialMatch: false,
        SecInfoNotMatch: false,
        ExactMatch: false,
      },
      ss_msg_cls: "",
      ss_msg: "",
    },
    ePayment: { value: "", isValid: true },
  });
  const [raceValidation, setRaceValidation] = useState(true);

  // PrePopulate
  useEffect(() => {
    // Race Data prepopulate
    let arrRace = JSON.stringify(patientInformation.additionalInformation.race);
    let arrRaceLookUp = JSON.stringify(lookUpData.race);
    arrRace = JSON.parse(arrRace);
    arrRaceLookUp = JSON.parse(arrRaceLookUp);
    arrRaceLookUp.map((data) => {
      arrRace.map((val) => {
        if (
          data.value == val.pyValue ||
          (data.value == val.value && val.isChecked)
        ) {
          data.isChecked = true;
        }
      });
    });
   if(appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other"){
     setPersonalInfo((prevState) => ({
       ...prevState,
       PayableToFirstName: {
         value: patientInformation.payableInformations.firstName,
         isValid: true,
         required: true,
       },
       PayableToLastName: {
         value: patientInformation.payableInformations.lastName,
         isValid: true,
         required: true,
       },
       PayableAddressLine1: {
         value: patientInformation.payableInformations.address.addressLine1,
         isValid: true,
         required: true,
       },
       PayableAddressLine2: {
         value: patientInformation.payableInformations.address.addressLine2,
         isValid: true,
         required: true,
       },
       PayableCity: {
         value: patientInformation.payableInformations.address.city,
         isValid: true,
         required: true,
       },
       PayableState: {
         value: patientInformation.payableInformations.address.state,
         isValid: true,
         required: true,
       },
       PayableZipCode: {
         value: patientInformation.payableInformations.address.zipCode,
         isValid: true,
         required: true,
       },
      //  isPayableAddressVerified: patientInformation.payableInformations.address.isPayableAddressVerified,
      //  payable:{
      //  smartyStreetMatches:{
      //      NoMatch: patientInformation.payableInformations.address.smartyStreetMatches.NoMatch,
      //      PartialMatch: patientInformation.payableInformations.address.smartyStreetMatches.PartialMatch,
      //      SecInfoNotMatch: patientInformation.payableInformations.address.smartyStreetMatches.SecInfoNotMatch,
      //      ExactMatch: patientInformation.payableInformations.address.smartyStreetMatches.ExactMatch,
      //    },
      //    ss_msg:patientInformation.payableInformations.address.ss_msg,
      //    ss_msg_cls: patientInformation.payableInformations.address.ss_msg_cls,
      //  },
     }))

    }
    setPersonalInfo((prevState) => ({
      ...prevState,
      addressType: { value: "Home", isValid: true },
      addressLine1: {
        value: patientInformation.address.addressLine1,
        isValid: true,
      },
      addressLine2: {
        value: patientInformation.address.addressLine2,
        isValid: true,
      },
      city: { value: patientInformation.address.city, isValid: true },
      state: { value: patientInformation.address.state, isValid: true },
      zipcode: { value: patientInformation.address.zipCode, isValid: true },
      contactby: {
        value: patientInformation.contactDetails.methodOfContact,
        isValid: true,
      },
      preferedLanguage: {
        value: patientInformation.contactDetails.preferedLanguage,
        isValid: true,
      },
      email: { value: patientInformation.contactDetails.email, isValid: true },
      emailType: {
        value: patientInformation.contactDetails.emailType,
        isValid: true,
      },
      emailOwner: {
        value: patientInformation.contactDetails.emailOwner,
        isValid: true,
      },
      phoneType: {
        value: patientInformation.contactDetails.phoneType,
        isValid: true,
      },
      phoneNumber: {
        value: patientInformation.contactDetails.phoneNumber,
        isValid: true,
      },
      contactSequence: { value: "Primary", isValid: true },
      hasGuardian: patientInformation.hasGuardian,
      guardianFirstName: {
        value: patientInformation.guardianDetails.firstName,
        isValid: true,
      },
      guardianLastName: {
        value: patientInformation.guardianDetails.lastName,
        isValid: true,
      },
      guardianSuffix: {
        value: patientInformation.guardianDetails.suffix,
        isValid: true,
      },
      guardianDOB: {
        value: patientInformation.guardianDetails.dateOfBirth,
        isValid: true,
      },
      guardianSSN: {
        value: patientInformation.guardianDetails.ssn,
        isValid: true,
      },
      guardianAlien: {
        value: patientInformation.guardianDetails.alienNumber,
        isValid: true,
      },
      guardianRelationshipToPatient: {
        value: patientInformation.guardianDetails.relationshipToPatient,
        isValid: true,
      },
      guardianEmployment: {
        value: patientInformation.guardianDetails.employementStatus,
        isValid: true,
      },
      guardianEmail: {
        value: patientInformation.guardianDetails.email,
        isValid: true,
      },
      guardianEmailType: {
        value: patientInformation.guardianDetails.emailType,
        isValid: true,
      },
      isPhoneNumberChecked:
        patientInformation.guardianDetails.isPhoneNumberSameAsPatient,
      isAddressChecked:
        patientInformation.guardianDetails.isAddressSameAsPatient,
      guardianAddressLine1: {
        value: patientInformation.guardianDetails.address.addressLine1,
        isValid: true,
      },
      guardianAddressLine2: {
        value: patientInformation.guardianDetails.address.addressLine2,
        isValid: true,
      },
      guardianCity: {
        value: patientInformation.guardianDetails.address.city,
        isValid: true,
      },
      guardianState: {
        value: patientInformation.guardianDetails.address.state,
        isValid: true,
      },
      guardianZipcode: {
        value: patientInformation.guardianDetails.address.zipCode,
        isValid: true,
      },
      guardianPhoneType: {
        value:
          patientInformation.guardianDetails.PhoneCommunication.phoneType,
        isValid: true,
      },
      guardianPhoneNumber: {
        value: patientInformation.guardianDetails.PhoneCommunication.phoneNumber,
        isValid: true,
      },
      gender: {
        value: patientInformation.additionalInformation.gender,
        isValid: true,
      },

      employementStatus: {
        value: patientInformation.additionalInformation.employementStatus,
        isValid: true,
      },
      veteran: {
        value: patientInformation.additionalInformation.veteran,
        isValid: true,
      },
      maritalStatus: {
        value: patientInformation.additionalInformation.maritalStatus,
        isValid: true,
      },
      householdSize: {
        value: patientInformation.additionalInformation.housHoldSize,
        isValid: true,
      },
      origin: {
        value: patientInformation.additionalInformation.hispanicOrgin,
        isValid: true,
      },
      race: arrRaceLookUp,
      raceOther: { value: patientInformation.additionalInformation.raceOther, isValid: true },
      copayPrograms: {
        value: patientInformation.additionalInformation.copayPrograms,
        isValid: true,
        isChecked:
          patientInformation.additionalInformation.copayProgramsChecked,
      },
      relationshipToPatient: {
        value: "Partner",
        isValid: true,
      },
      applicantFirstName: {
        value: applicantData.FirstName,
        isValid: true,
      },
      applicantLastName: {
        value: applicantData.LastName,
        isValid: true,
      },
      applicantPhoneNumber: {
        value: applicantData.PhoneNumber,
        isValid: true,
      },
      referredBy: { value: patientInformation.referredBy, isValid: true },
      referredOther: { value: patientInformation.referredOther, isValid: true },
      healthCareProfessionalFirstName: {
        value: patientInformation.healthCare.healthCareProfessionalFirstName,
        isValid: true,
      },
      healthCareProfessionalLastName: {
        value: patientInformation.healthCare.healthCareProfessionalLastName,
        isValid: true,
      },
      healthCareProfessionalFacilityName: {
        value: patientInformation.healthCare.healthCareProfessionalFacilityName,
        isValid: true,
      },
      healthCareProfessionalPosition: {
        value: patientInformation.healthCare.healthCareProfessionalPosition,
        isValid: true,
      },
      healthCareFacilityName: {
        value: patientInformation.healthCare.healthCareFacilityName,
        isValid: true,
      },
      healthCareAddressLine1: {
        value: patientInformation.healthCare.healthCareAddressLine1,
        isValid: true,
      },
      healthCareAddressLine2: {
        value: patientInformation.healthCare.healthCareAddressLine2,
        isValid: true,
      },
      healthCareCity: {
        value: patientInformation.healthCare.healthCareCity,
        isValid: true,
      },
      healthCareState: {
        value: patientInformation.healthCare.healthCareState,
        isValid: true,
      },
      healthCareZipcode: {
        value: patientInformation.healthCare.healthCareZipcode,
        isValid: true,
      },
      healthCarePhoneNumber: {
        value: patientInformation.healthCare.healthCarePhoneNumber,
        isValid: true,
      },
      healthCareEmail: {
        value: patientInformation.healthCare.healthCareEmail,
        isValid: true,
      },
      healthCareEmailType: {
        value: patientInformation.healthCare.healthCareEmailType,
        isValid: true,
      },
      sameAsHealthCare: patientInformation.healthCare.sameAsHealthCare,
      ePayment: { value: patientInformation.ePayment, isValid: true }
    }));
  }, []);

  //personal information validation function
  function personalInfoValidation() {
    //validationg contact details
    let isValidContactDetails =
        personalInfo.contactby.value != "" &&
        personalInfo.contactby.isValid &&
        personalInfo.preferedLanguage.value != "" &&
        personalInfo.preferedLanguage.isValid &&
        personalInfo.phoneType.value != "" &&
        personalInfo.phoneType.isValid &&
        personalInfo.phoneNumber.value != "" &&
        personalInfo.phoneNumber.isValid &&
         (patientInformation.Program == "FAF" ?
        (personalInfo.contactSequence.value != "" && personalInfo.contactSequence.isValid ? true : false) : true
      )
        if(personalInfo.contactby.value == "Email"){
          isValidContactDetails= isValidContactDetails && 
          personalInfo.email.value != "" &&
          personalInfo.email.isValid &&
          personalInfo.emailType.value != "" &&
          personalInfo.emailType.isValid &&
          personalInfo.emailOwner.value != "" &&
          personalInfo.emailOwner.isValid ? true :false
        }else{
            if(personalInfo.email.value != "" || personalInfo.emailType.value != "" ||  personalInfo.emailOwner.value){
              isValidContactDetails= isValidContactDetails && 
              personalInfo.email.value != "" &&
              personalInfo.email.isValid &&
              personalInfo.emailType.value != "" &&
              personalInfo.emailType.isValid &&
              personalInfo.emailOwner.value != "" &&
              personalInfo.emailOwner.isValid ? true :false
            }
        }
    // if (personalInfo.contactby.value == "Mail") {
    //   isValidContactDetails =
    //     personalInfo.contactby.value != "" &&
    //     personalInfo.contactby.isValid &&
    //     personalInfo.preferedLanguage.value != "" &&
    //     personalInfo.preferedLanguage.isValid &&
    //     personalInfo.email.value != "" &&
    //     personalInfo.email.isValid &&
    //     personalInfo.emailType.value != "" &&
    //     personalInfo.emailType.isValid &&
    //     personalInfo.emailOwner.value != "" &&
    //     personalInfo.emailOwner.isValid &&
    //     personalInfo.phoneType.value != "" &&
    //     personalInfo.phoneType.isValid &&
    //     personalInfo.phoneNumber.value != "" &&
    //     personalInfo.phoneNumber.isValid &&
    //     personalInfo.contactSequence.value != "" &&
    //     personalInfo.contactSequence.isValid;
    // } else if (personalInfo.contactby.value == "Email") {
    //   if (
    //     personalInfo.email.value != "" ||
    //     personalInfo.emailType.value != "" ||
    //     personalInfo.emailOwner.value != ""
    //   ) {
    //     isValidContactDetails =
    //       personalInfo.contactby.value != "" &&
    //       personalInfo.contactby.isValid &&
    //       personalInfo.preferedLanguage.value != "" &&
    //       personalInfo.preferedLanguage.isValid &&
    //       personalInfo.email.value != "" &&
    //       personalInfo.email.isValid &&
    //       personalInfo.emailType.value != "" &&
    //       personalInfo.emailType.isValid &&
    //       personalInfo.emailOwner.value != "" &&
    //       personalInfo.emailOwner.isValid &&
    //       personalInfo.phoneType.value != "" &&
    //       personalInfo.phoneType.isValid &&
    //       personalInfo.phoneNumber.value != "" &&
    //       personalInfo.phoneNumber.isValid &&
    //       personalInfo.contactSequence.value != "" &&
    //       personalInfo.contactSequence.isValid;
    //   } else {
    //     isValidContactDetails =
    //       personalInfo.preferedLanguage.value != "" &&
    //       personalInfo.preferedLanguage.isValid &&
    //       personalInfo.phoneType.value != "" &&
    //       personalInfo.phoneType.isValid &&
    //       personalInfo.phoneNumber.value != "" &&
    //       personalInfo.phoneNumber.isValid &&
    //       personalInfo.contactSequence.value != "" &&
    //       personalInfo.contactSequence.isValid;
    //   }
    // }

    //validating guardian info
    let isValidGuardian =
      personalInfo.guardianFirstName.value != "" &&
      personalInfo.guardianFirstName.isValid &&
      personalInfo.guardianLastName.isValid &&
      personalInfo.guardianSuffix.isValid &&
      personalInfo.guardianDOB.value != "" &&
      personalInfo.guardianDOB.isValid &&
      ((personalInfo.guardianSSN.value != "" &&
        personalInfo.guardianSSN.isValid) ||
        (personalInfo.guardianAlien.value != "" &&
          personalInfo.guardianAlien.isValid)) &&
      personalInfo.guardianRelationshipToPatient.value != "" &&
      personalInfo.guardianRelationshipToPatient.isValid &&
      personalInfo.guardianEmployment.value != "" &&
      personalInfo.guardianEmployment.isValid &&
      personalInfo.guardianEmail.isValid &&
      personalInfo.guardianEmailType.isValid;

    if (personalInfo.guardianEmail.value != "" || personalInfo.guardianEmailType.value != "") {
      isValidGuardian = personalInfo.guardianEmail.value != "" && personalInfo.guardianEmail.isValid && personalInfo.guardianEmailType.value != "" && personalInfo.guardianEmailType.isValid;
    }

    //validating guardian address
    let isValidGuardianAddress = true;
    if (personalInfo.hasGuardian) {
      if (personalInfo.isAddressChecked) {
        isValidGuardianAddress = true;
      } else {
        isValidGuardianAddress =
          personalInfo.guardianAddressLine1.value != "" &&
          personalInfo.guardianAddressLine1.isValid &&
          personalInfo.guardianAddressLine2.isValid &&
          personalInfo.guardianCity.value != "" &&
          personalInfo.guardianCity.isValid &&
          personalInfo.guardianState.value != "" &&
          personalInfo.guardianState.isValid &&
          personalInfo.guardianZipcode.value != "" &&
          personalInfo.guardianZipcode.isValid &&
          personalInfo.isGuardianAddressVerified;
        !isValidGuardianAddress &&
          !personalInfo.isGuardianAddressVerified &&
          toast.error("Please Verify guardian Address");
      }
    }
   let isValidAwardPayableAddress =true
     // payable validations
     if(appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other"){
       isValidAwardPayableAddress =
       personalInfo.PayableToFirstName.value != "" &&
       personalInfo.PayableToFirstName.isValid &&
       personalInfo.PayableToLastName.value != "" &&
       personalInfo.PayableToLastName.isValid &&
       personalInfo.PayableAddressLine1.value != "" &&
       personalInfo.PayableAddressLine1.isValid &&
       personalInfo.PayableCity.value != "" &&
       personalInfo.PayableCity.isValid &&
       personalInfo.PayableState.value != "" &&
       personalInfo.PayableState.isValid &&
       personalInfo.PayableZipCode.value != "" &&
       personalInfo.PayableZipCode.isValid &&
       personalInfo.isPayableAddressVerified;
       !isValidAwardPayableAddress &&
       !personalInfo.isPayableAddressVerified &&
     toast.error("Verify AwardPayable address to proceed");
     }else{
      isValidAwardPayableAddress =true
     }
    //validating guardian phone number
    let isValidGuardianPhone = personalInfo.isPhoneNumberChecked
      ? personalInfo.isPhoneNumberChecked
      : personalInfo.guardianPhoneType.value != "" &&
      personalInfo.guardianPhoneType.isValid &&
      personalInfo.guardianPhoneNumber.value != "" &&
      personalInfo.guardianPhoneNumber.isValid;

    const isValidAdditionalInfo =
      personalInfo.gender.value != "" &&
      personalInfo.gender.isValid &&
      personalInfo.employementStatus.value != "" &&
      personalInfo.employementStatus.isValid &&
      personalInfo.veteran.value != "" &&
      personalInfo.veteran.isValid &&
      personalInfo.maritalStatus.value != "" &&
      personalInfo.maritalStatus.isValid &&
      personalInfo.householdSize.value != "" &&
      personalInfo.householdSize.isValid &&
      personalInfo.origin.value != "" &&
      personalInfo.origin.isValid;

    isValidGuardian = personalInfo.hasGuardian
      ? isValidGuardian && isValidGuardianAddress && isValidGuardianPhone
      : true;

    //validating race
    let isValidRace;
    let tempArr = [];
    personalInfo.race.map((other) => {
      if (other.value == "Other" && other.isChecked) {
        isValidRace =
          personalInfo.raceOther.value != "" && personalInfo.raceOther.isValid;
        isValidRace && tempArr.push("true");
      } else {
        other.isChecked == true && tempArr.push("true");
      }
    });
    isValidRace = tempArr.length > 0;
    setRaceValidation(isValidRace);
    !isValidRace && toast.error("Please provide the Race information");

    //validating applicant information
    let isValidApplicant =
      personalInfo.relationshipToPatient.value != "Self"
        ? personalInfo.applicantFirstName.value != "" &&
        personalInfo.applicantFirstName.isValid &&
        personalInfo.applicantLastName.value != "" &&
        personalInfo.applicantLastName.isValid &&
        personalInfo.applicantPhoneNumber.value != "" &&
        personalInfo.applicantPhoneNumber.isValid
        : personalInfo.relationshipToPatient.value != "" &&
        personalInfo.relationshipToPatient.isValid;
    if (isValidApplicant && isPDMI) {
      isValidApplicant =
        personalInfo.gender.value == "Male" ||
        personalInfo.gender.value == "Female";
      !(
        personalInfo.gender.value == "Male" ||
        personalInfo.gender.value == "Female"
      ) && toast.error("Gender: Invalid value for PDMI-enabled funds.");
    }

    // validating refferal information
    let isValidRefferal;
    if (
      personalInfo.referredBy.value != "" &&
      personalInfo.referredBy.isValid
    ) {
      if (personalInfo.referredBy.value == "Other/Unknown") {
        isValidRefferal =
          personalInfo.referredOther.value != "" &&
          personalInfo.referredOther.isValid;
      } else if (
        personalInfo.referredBy.value == "Healthcare Professional" ||
        personalInfo.referredBy.value == "Healthcare Facility"
      ) {
        isValidRefferal = personalInfo.sameAsHealthCare ? true : (personalInfo.healthCarePhoneNumber.value != "" && personalInfo.healthCarePhoneNumber.isValid)
        isValidRefferal = isValidRefferal && personalInfo.healthCareEmail.value != "" ? personalInfo.healthCareEmail.isValid : true
        isValidRefferal = isValidRefferal && personalInfo.healthCareAddressLine1.value != "" &&
          personalInfo.healthCareAddressLine1.isValid &&
          personalInfo.healthCareAddressLine2.isValid &&
          personalInfo.healthCareCity.value != "" &&
          personalInfo.healthCareCity.isValid &&
          personalInfo.healthCareState.value != "" &&
          personalInfo.healthCareState.isValid &&
          personalInfo.healthCareZipcode.value != "" &&
          personalInfo.healthCareZipcode.isValid &&
          personalInfo.isHealthCareAddressVerified;
        !isValidRefferal &&
          !personalInfo.isHealthCareAddressVerified &&
          toast.error("Please Verify the Address");
        if (isValidRefferal) {
          if (
            personalInfo.healthCareEmail.value != "" &&
            personalInfo.healthCareEmail.isValid
          ) {
            isValidRefferal =
              personalInfo.healthCareEmailType.value != "" && personalInfo.healthCareEmailType.value != undefined &&
              personalInfo.healthCareEmailType.isValid;
          }
          if (isValidRefferal && personalInfo.referredBy.value == "Healthcare Professional") {
            const sameAsHealthCare = personalInfo.sameAsHealthCare
              ? true
              : personalInfo.healthCareProfessionalFirstName.value != "" &&
              personalInfo.healthCareProfessionalFirstName.isValid &&
              personalInfo.healthCareProfessionalLastName.value != "" &&
              personalInfo.healthCareProfessionalLastName.isValid &&
              personalInfo.healthCarePhoneNumber.value != "" &&
              personalInfo.healthCarePhoneNumber.isValid;
            isValidRefferal =
              sameAsHealthCare &&
              personalInfo.healthCareProfessionalFacilityName.value != "" &&
              personalInfo.healthCareProfessionalFacilityName.isValid &&
              personalInfo.healthCareProfessionalPosition.value != "" &&
              personalInfo.healthCareProfessionalPosition.isValid;
          } else {
            isValidRefferal =
              personalInfo.healthCareFacilityName.value != "" &&
              personalInfo.healthCareFacilityName.isValid && isValidRefferal;
          }
        } else {
          isValidRefferal = false
        }
      } else {
        isValidRefferal =
          personalInfo.referredBy.value != "" &&
          personalInfo.referredBy.isValid;
      }
    } else {
      isValidRefferal = false;
    }

    //ePayment Validation
    const isValidEPayment = isEPaymentAvailable
      ? personalInfo.ePayment.value != "" && personalInfo.ePayment.isValid
      : true;

    let isValidcopayPrograms =
      patientInformation.Program == "CPR"
        ? personalInfo.copayPrograms.isChecked
          ? personalInfo.copayPrograms.value != ""
          : true
        : true;
    //validating overall personal information
    if (
      isValidContactDetails &&
      isValidGuardian &&
      isValidAdditionalInfo &&
      isValidRace &&
      isValidApplicant &&
      isValidRefferal &&
      isValidEPayment &&
      isValidcopayPrograms && ((appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other") ? isValidAwardPayableAddress : isValidAwardPayableAddress  )
    ) {
      dispatch(personalInfoData(personalInfo));
      return true;
    } else {
      toast.error(errorMessage.mandatoryFieldsToastErrorMessage);
    const validateField = (field, isValidCondition) => ({
      value: personalInfo[field].value,
      isValid: isValidCondition ? true : false,
    });
    if (personalInfo.contactby.value !== "") {
      if (personalInfo.contactby.value === "Email") {
        const isEmailValid = personalInfo.email.value && personalInfo.email.isValid;
        const isEmailTypeValid = personalInfo.emailType.value && personalInfo.emailType.isValid;
        const isEmailOwnerValid = personalInfo.emailOwner.value && personalInfo.emailOwner.isValid;
    
        if (
          personalInfo.email.value !== "" || 
          personalInfo.emailType.value !== "" || 
          personalInfo.emailOwner.value !== ""
        ) {
          setPersonalInfo((prevState) => ({
            ...prevState,
            email: validateField("email", isEmailValid),
            emailType: validateField("emailType", isEmailTypeValid),
            emailOwner: validateField("emailOwner", isEmailOwnerValid),
          }));
        } else {
          setPersonalInfo((prevState) => ({
            ...prevState,
            email: validateField("email", isEmailValid),
            emailType: validateField("emailType", isEmailTypeValid),
            emailOwner: validateField("emailOwner", isEmailOwnerValid),
          }));
        }
      } else {
        if (
          personalInfo.email.value === "" && 
          personalInfo.emailType.value === "" && 
          personalInfo.emailOwner.value === ""
        ) {
          setPersonalInfo((prevState) => ({
            ...prevState,
            email: { value: "", isValid: true },
            emailType: { value: "", isValid: true },
            emailOwner: { value: "", isValid: true },
          }));
        } else {
          setPersonalInfo((prevState) => ({
            ...prevState,
            email: validateField("email", personalInfo.email.value && personalInfo.email.isValid),
            emailType: validateField("emailType", personalInfo.emailType.value && personalInfo.emailType.isValid),
            emailOwner: validateField("emailOwner", personalInfo.emailOwner.value && personalInfo.emailOwner.isValid),
          }));
        }
      }
    } else {
      setPersonalInfo((prevState) => ({
        ...prevState,
        email: validateField("email", personalInfo.email.value && personalInfo.email.isValid),
        emailType: validateField("emailType", personalInfo.emailType.value && personalInfo.emailType.isValid),
        emailOwner: validateField("emailOwner", personalInfo.emailOwner.value && personalInfo.emailOwner.isValid),
      }));
    }
    if(appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other"){
      setPersonalInfo((prevState) => ({
        ...prevState,
        PayableToFirstName: {
          value: personalInfo.PayableToFirstName.value,
          isValid:personalInfo.PayableToFirstName.value != "" &&
            personalInfo.PayableToFirstName.isValid,
        },
        PayableToLastName: {
          value: personalInfo.PayableToLastName.value,
          isValid:personalInfo.PayableToLastName.value != "" &&
            personalInfo.PayableToLastName.isValid,
        },
        PayableAddressLine1: {
          value: personalInfo.PayableAddressLine1.value,
          isValid:personalInfo.PayableAddressLine1.value != "" &&
            personalInfo.PayableAddressLine1.isValid,
        },
        PayableAddressLine2: {
          value: personalInfo.PayableAddressLine2.value,
          isValid: personalInfo.PayableAddressLine2.isValid,
        },
        PayableCity: {
          value: personalInfo.PayableCity.value,
          isValid:personalInfo.PayableCity.value != "" &&
            personalInfo.PayableCity.isValid,
        },
        PayableState: {
          value: personalInfo.PayableState.value,
          isValid:personalInfo.PayableState.value != "" &&
            personalInfo.PayableState.isValid,
        },
        PayableZipCode: {
          value: personalInfo.PayableZipCode.value,
          isValid:personalInfo.PayableZipCode.value != "" &&
            personalInfo.PayableZipCode.isValid,
        }
      }))
     }
      setPersonalInfo((prevState) => ({
        ...prevState,
        contactby: {
          value: personalInfo.contactby.value,
          isValid:
            personalInfo.contactby.value != "" &&
            personalInfo.contactby.isValid,
        },
        preferedLanguage: {
          value: personalInfo.preferedLanguage.value,
          isValid:
            personalInfo.preferedLanguage.value != "" &&
            personalInfo.preferedLanguage.isValid,
        },
        // email: {
        //   value: personalInfo.email.value,
        //   isValid:
        //     (personalInfo.email.value != "" ||
        //       personalInfo.emailType.value != "" ||
        //       personalInfo.emailOwner.value != "") &&
        //       personalInfo.email.value != "" &&
        //       personalInfo.email.isValid
        //       ? personalInfo.email.isValid
        //       : false,
        // },
        // emailType: {
        //   value: personalInfo.emailType.value,
        //   isValid:
        //     (personalInfo.email.value != "" ||
        //       personalInfo.emailType.value != "" ||
        //       personalInfo.emailOwner.value != "") &&
        //       personalInfo.emailType.value != "" &&
        //       personalInfo.emailType.isValid
        //       ? personalInfo.emailType.isValid
        //       : false,
        // },
        // emailOwner: {
        //   value: personalInfo.emailOwner.value,
        //   isValid:
        //     (personalInfo.email.value != "" ||
        //       personalInfo.emailType.value != "" ||
        //       personalInfo.emailOwner.value != "") &&
        //       personalInfo.emailOwner.value != "" &&
        //       personalInfo.emailOwner.isValid
        //       ? personalInfo.emailOwner.isValid
        //       : false,
        // },
        phoneType: {
          value: personalInfo.phoneType.value,
          isValid:
            personalInfo.phoneType.value != "" &&
            personalInfo.phoneType.isValid,
        },
        phoneNumber: {
          value: personalInfo.phoneNumber.value,
          isValid:
            personalInfo.phoneNumber.value != "" &&
            personalInfo.phoneNumber.isValid,
        },
        contactSequence: {
          value: personalInfo.contactSequence.value,
          isValid:
            personalInfo.contactSequence.value != "" &&
            personalInfo.contactSequence.isValid,
        },
        guardianFirstName: {
          value: personalInfo.guardianFirstName.value,
          isValid:
            personalInfo.guardianFirstName.value != "" &&
            personalInfo.guardianFirstName.isValid,
        },
        guardianLastName: {
          value: personalInfo.guardianLastName.value,
          isValid:
            personalInfo.guardianLastName.value != "" &&
            personalInfo.guardianLastName.isValid,
        },
        guardianSuffix: {
          value: personalInfo.guardianSuffix.value,
          isValid: personalInfo.guardianSuffix.isValid,
        },
        guardianDOB: {
          value: personalInfo.guardianDOB.value,
          isValid:
            personalInfo.guardianDOB.value != "" &&
            personalInfo.guardianDOB.isValid,
        },
        guardianSSN: {
          value: personalInfo.guardianSSN.value,
          isValid: ((personalInfo.guardianSSN.value != "" &&
            personalInfo.guardianSSN.isValid) ||
            (personalInfo.guardianAlien.value != "" &&
              personalInfo.guardianAlien.isValid))
        },
        guardianRelationshipToPatient: {
          value: personalInfo.guardianRelationshipToPatient.value,
          isValid:
            personalInfo.guardianRelationshipToPatient.value != "" &&
            personalInfo.guardianRelationshipToPatient.isValid,
        },
        guardianEmployment: {
          value: personalInfo.guardianEmployment.value,
          isValid:
            personalInfo.guardianEmployment.value != "" &&
            personalInfo.guardianEmployment.isValid,
        },
        guardianEmail: {
          value: personalInfo.guardianEmail.value,
          isValid: personalInfo.guardianEmailType.value != "" ? (personalInfo.guardianEmail.value != "" && personalInfo.guardianEmail.isValid) : personalInfo.guardianEmail.isValid,
        },
        guardianEmailType: {
          value: personalInfo.guardianEmailType.value,
          isValid: (personalInfo.guardianEmail.value != "" && personalInfo.guardianEmail.isValid) ? (personalInfo.guardianEmailType.value != "" && personalInfo.guardianEmailType.isValid) : personalInfo.guardianEmailType.isValid,
        },
        guardianAddressLine1: {
          value: personalInfo.guardianAddressLine1.value,
          isValid: personalInfo.isAddressChecked
            ? personalInfo.guardianAddressLine1.isValid
            : personalInfo.guardianAddressLine1.value != "" &&
            personalInfo.guardianAddressLine1.isValid,
        },
        guardianAddressLine2: {
          value: personalInfo.guardianAddressLine2.value,
          isValid: personalInfo.guardianAddressLine2.isValid,
        },
        guardianCity: {
          value: personalInfo.guardianCity.value,
          isValid: personalInfo.isAddressChecked
            ? personalInfo.guardianCity.isValid
            : personalInfo.guardianCity.value != "" &&
            personalInfo.guardianCity.isValid,
        },
        guardianState: {
          value: personalInfo.guardianState.value,
          isValid: personalInfo.isAddressChecked
            ? personalInfo.guardianState.isValid
            : personalInfo.guardianState.value != "" &&
            personalInfo.guardianState.isValid,
        },
        guardianZipcode: {
          value: personalInfo.guardianZipcode.value,
          isValid: personalInfo.isAddressChecked
            ? personalInfo.guardianZipcode.isValid
            : personalInfo.guardianZipcode.value != "" &&
            personalInfo.guardianZipcode.isValid,
        },
        guardianPhoneType: {
          value: personalInfo.guardianPhoneType.value,
          isValid: personalInfo.isPhoneNumberChecked
            ? personalInfo.guardianPhoneType.isValid
            : personalInfo.guardianPhoneType.value != "" &&
            personalInfo.guardianPhoneType.isValid,
        },
        guardianPhoneNumber: {
          value: personalInfo.guardianPhoneNumber.value,
          isValid: personalInfo.isPhoneNumberChecked
            ? personalInfo.guardianPhoneNumber.isValid
            : personalInfo.guardianPhoneNumber.value != "" &&
            personalInfo.guardianPhoneNumber.isValid,
        },
        gender: {
          value: personalInfo.gender.value,
          isValid: isPDMI
            ? personalInfo.gender.value == "Male" ||
            personalInfo.gender.value == "Female"
            : personalInfo.gender.value != "" && personalInfo.gender.isValid,
        },
        employementStatus: {
          value: personalInfo.employementStatus.value,
          isValid:
            personalInfo.employementStatus.value != "" &&
            personalInfo.employementStatus.isValid,
        },
        veteran: {
          value: personalInfo.veteran.value,
          isValid:
            personalInfo.veteran.value != "" && personalInfo.veteran.isValid,
        },
        maritalStatus: {
          value: personalInfo.maritalStatus.value,
          isValid:
            personalInfo.maritalStatus.value != "" &&
            personalInfo.maritalStatus.isValid,
        },
        householdSize: {
          value: personalInfo.householdSize.value,
          isValid:
            personalInfo.householdSize.value != "" &&
            personalInfo.householdSize.isValid,
        },
        raceOther: {
          value: personalInfo.raceOther.value,
          isValid:
            personalInfo.raceOther.value != "" &&
            personalInfo.raceOther.isValid,
        },
        origin: {
          value: personalInfo.origin.value,
          isValid:
            personalInfo.origin.value != "" && personalInfo.origin.isValid,
        },
        copayPrograms: {
          value: personalInfo.copayPrograms.value,
          isValid:
            personalInfo.copayPrograms.isChecked == true
              ? personalInfo.copayPrograms.value != ""
              : true,
          isChecked: personalInfo.copayPrograms.isChecked,
        },
        relationshipToPatient: {
          value: personalInfo.relationshipToPatient.value,
          isValid:
            personalInfo.relationshipToPatient.value != "" &&
            personalInfo.relationshipToPatient.isValid,
        },
        applicantFirstName: {
          value: personalInfo.applicantFirstName.value,
          isValid:
            personalInfo.relationshipToPatient.value != "" &&
              personalInfo.relationshipToPatient.value != "Self"
              ? personalInfo.applicantFirstName.value != "" &&
              personalInfo.applicantFirstName.isValid
              : personalInfo.applicantFirstName.isValid,
        },
        applicantLastName: {
          value: personalInfo.applicantLastName.value,
          isValid:
            personalInfo.relationshipToPatient.value != "" &&
              personalInfo.relationshipToPatient.value != "Self"
              ? personalInfo.applicantLastName.value != "" &&
              personalInfo.applicantLastName.isValid
              : personalInfo.applicantLastName.isValid,
        },
        applicantPhoneNumber: {
          value: personalInfo.applicantPhoneNumber.value,
          isValid:
            personalInfo.relationshipToPatient.value != "" &&
              personalInfo.relationshipToPatient.value != "Self"
              ? personalInfo.applicantPhoneNumber.value != "" &&
              personalInfo.applicantPhoneNumber.isValid
              : personalInfo.applicantPhoneNumber.isValid,
        },
        referredBy: {
          value: personalInfo.referredBy.value,
          isValid:
            personalInfo.referredBy.value != "" &&
            personalInfo.referredBy.isValid,
        },
        healthCareProfessionalFirstName: {
          value: personalInfo.healthCareProfessionalFirstName.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.sameAsHealthCare ? true : (personalInfo.healthCareProfessionalFirstName.value != "" &&
                personalInfo.healthCareProfessionalFirstName.isValid)
              : personalInfo.healthCareProfessionalFirstName.isValid,
        },
        healthCareProfessionalLastName: {
          value: personalInfo.healthCareProfessionalLastName.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.sameAsHealthCare ? true : (personalInfo.healthCareProfessionalLastName.value != "" &&
                personalInfo.healthCareProfessionalLastName.isValid)
              : personalInfo.healthCareProfessionalLastName.isValid,
        },
        healthCareProfessionalFacilityName: {
          value: personalInfo.healthCareProfessionalFacilityName.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.healthCareProfessionalFacilityName.value != "" &&
              personalInfo.healthCareProfessionalFacilityName.isValid
              : personalInfo.healthCareProfessionalFacilityName.isValid,
        },
        healthCareProfessionalPosition: {
          value: personalInfo.healthCareProfessionalPosition.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.healthCareProfessionalPosition.value != "" &&
              personalInfo.healthCareProfessionalPosition.isValid
              : personalInfo.healthCareProfessionalPosition.isValid,
        },
        healthCareFacilityName: {
          value: personalInfo.healthCareFacilityName.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Facility"
              ? personalInfo.healthCareFacilityName.value != "" &&
              personalInfo.healthCareFacilityName.isValid
              : personalInfo.healthCareFacilityName.isValid,
        },
        healthCareAddressLine1: {
          value: personalInfo.healthCareAddressLine1.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.healthCareAddressLine1.value != "" &&
              personalInfo.healthCareAddressLine1.isValid
              : personalInfo.healthCareAddressLine1.isValid,
        },
        healthCareAddressLine2: {
          value: personalInfo.healthCareAddressLine2.value,
          isValid: personalInfo.healthCareAddressLine2.isValid,
        },
        healthCareCity: {
          value: personalInfo.healthCareCity.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.healthCareCity.value != "" &&
              personalInfo.healthCareCity.isValid
              : personalInfo.healthCareCity.isValid,
        },
        healthCareState: {
          value: personalInfo.healthCareState.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.healthCareState.value != "" &&
              personalInfo.healthCareState.isValid
              : personalInfo.healthCareState.isValid,
        },
        healthCareZipcode: {
          value: personalInfo.healthCareZipcode.value,
          isValid:
            personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional"
              ? personalInfo.healthCareZipcode.value != "" &&
              personalInfo.healthCareZipcode.isValid
              : personalInfo.healthCareZipcode.isValid,
        },
        healthCarePhoneNumber: {
          value: personalInfo.healthCarePhoneNumber.value,
          isValid:
            (personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional")
              ? personalInfo.sameAsHealthCare ? true : (personalInfo.healthCarePhoneNumber.value != "" &&
                personalInfo.healthCarePhoneNumber.isValid)
              : personalInfo.healthCarePhoneNumber.isValid,
        },
        healthCareEmail: {
          value: personalInfo.healthCareEmail.value,
          isValid:
            (personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional")
            && personalInfo.healthCareEmail.isValid,
        },
        healthCareEmailType: {
          value: personalInfo.healthCareEmailType.value,
          isValid:
            ((personalInfo.referredBy.value == "Healthcare Facility" ||
              personalInfo.referredBy.value == "Healthcare Professional") &&
              (personalInfo.healthCareEmail.value != "" &&
                personalInfo.healthCareEmail.isValid))
              ? (personalInfo.healthCareEmailType.value != "" && personalInfo.healthCareEmailType.value != undefined &&
                personalInfo.healthCareEmailType.isValid)
              : personalInfo.healthCareEmailType.isValid,
        },
        ePayment: {
          value: personalInfo.ePayment.value,
          isValid: isEPaymentAvailable
            ? personalInfo.ePayment.value && personalInfo.ePayment.isValid
            : true,
        },
      }));
      return false;
    }
  }

  //validating input their onChange
  const inputOnChange = (e, fieldvalidation, index) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (name == "race") {
      let tempArr = [...personalInfo.race];
      tempArr[index].isChecked = e.target.checked;
      setRaceValidation(true);
      setPersonalInfo((prevState) => ({
        ...prevState,
        race: tempArr,
      }));
    } else if (
      name == "isPhoneNumberChecked" ||
      name == "isAddressChecked" ||
      name == "sameAsHealthCare"
    ) {
      setPersonalInfo((prevState) => ({
        ...prevState,
        [name]: e.target.checked,
      }));
    } else if (name == "guardianSSN") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        guardianSSN: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        guardianAlien: {
          value: "",
          isValid: true,
        },
      }));
    } else if (name == "guardianAlien") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        guardianAlien: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        guardianSSN: {
          value: "",
          isValid: true,
        },
      }));
    } else if (name == "guardianEmailType") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        guardianEmailType: {
          value: inputValidate.value,
          isValid: inputValue.length > 0 ? inputValidate.isValid : true
        },
        guardianEmail: { value: personalInfo.guardianEmail.value, isValid: inputValue.length > 0 ? personalInfo.guardianEmail.isValid : true }
      }));
    } else if (name == "guardianEmail") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        guardianEmail: {
          value: inputValidate.value,
          isValid: inputValue.length > 0 ? inputValidate.isValid : true
        },
        guardianEmailType: { value: personalInfo.guardianEmailType.value, isValid: inputValue.length > 0 ? personalInfo.guardianEmailType.isValid : true }
      }));
    } else if (
      name == "guardianZipcode" ||
      name == "guardianCity" ||
      name == "guardianState" ||
      name == "guardianAddressLine2" ||
      name == "guardianAddressLine1"
    ) {
      setPersonalInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        guardian: {
          isVerified: false,
          smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
          },
          ss_msg_cls: "",
          ss_msg: "",
        },
      }));
    } else if ((appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other") &&
      name == "PayableZipCode" ||
      name == "PayableCity" ||
      name == "PayableState" ||
      name == "PayableAddressLine1" ||
      name == "PayableAddressLine2"
    ) {
      setPersonalInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        payable: {
          isVerified: false,
          smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
          },
          ss_msg_cls: "",
          ss_msg: "",
        },
      }));
    }else if (
      name == "healthCareZipcode" ||
      name == "healthCareCity" ||
      name == "healthCareState" ||
      name == "healthCareAddressLine2" ||
      name == "healthCareAddressLine1"
    ) {
      setPersonalInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        healthCare: {
          isVerified: false,
          smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
          },
          ss_msg_cls: "",
          ss_msg: "",
        },
      }));
    }
     else if (name == "copayProgramsCheck") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        copayPrograms: {
          value:
            e.target.checked == false ? "" : personalInfo.copayPrograms.value,
          isValid:
            personalInfo.copayPrograms.isChecked == false
              ? true
              : personalInfo.copayPrograms.isValid,
          isChecked: e.target.checked,
        },
      }));
    } else if (name == "copayPrograms") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        copayPrograms: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
          isChecked: personalInfo.copayPrograms.isChecked,
        },
      }));
    } else if (name == "referredBy") {
      setPersonalInfo((prevState) => ({
        ...prevState,
        referredBy: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
        healthCareAddressLine1: { value: "", isValid: true },
        healthCareAddressLine2: { value: "", isValid: true },
        healthCareCity: { value: "", isValid: true },
        healthCareState: { value: "", isValid: true },
        healthCareZipcode: { value: "", isValid: true },
        healthCarePhoneNumber: { value: "", isValid: true },
        healthCareEmail: { value: "", isValid: true },
        healthCareEmailType: { value: "", isValid: true },
      }));
    }else if(name == 'contactby'){
     if(inputValidate.value === "Mail"){
      if(personalInfo.email.value === '' && personalInfo.emailType.value === '' && personalInfo.emailOwner.value === ''){
        setPersonalInfo((prevState) => ({
          ...prevState,
          email: {
            value: '',
            isValid: true,
          },
          emailType: {
            value: '',
            isValid: true,
          },
          emailOwner: {
            value: '',
            isValid: true,
          },
        }));
      }
     }
     setPersonalInfo((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
    }else if (name === "email" || name === "emailType" || name === "emailOwner") {
      const isEmailEmpty = name === "email" ? inputValidate.value === '' : personalInfo.email.value === '';
      const isEmailTypeEmpty = name === "emailType" ? inputValidate.value === '' : personalInfo.emailType.value === '';
      const isEmailOwnerEmpty = name === "emailOwner" ? inputValidate.value === '' : personalInfo.emailOwner.value === '';
    
      if (personalInfo.contactby.value === "Mail") {
        setPersonalInfo((prevState) => ({
          ...prevState,
          email: {
            value: name === "email" ? inputValidate.value : prevState.email.value,
            isValid: isEmailTypeEmpty && isEmailOwnerEmpty && isEmailEmpty ? true : name === "email" ? inputValidate.isValid : prevState.email.isValid,
          },
          emailType: {
            value: name === "emailType" ? inputValidate.value : prevState.emailType.value,
            isValid: isEmailEmpty && isEmailOwnerEmpty && isEmailTypeEmpty ? true : name === "emailType" ? inputValidate.isValid : prevState.emailType.isValid,
          },
          emailOwner: {
            value: name === "emailOwner" ? inputValidate.value : prevState.emailOwner.value,
            isValid: isEmailEmpty && isEmailTypeEmpty && isEmailOwnerEmpty ? true : name === "emailOwner" ? inputValidate.isValid : prevState.emailOwner.isValid,
          },
        }));
      } else {
        // For non-"Mail" cases, validate the field directly
        setPersonalInfo((prevState) => ({
          ...prevState,
          [name]: {
            value: inputValidate.value,
            isValid: inputValidate.value === '' ? true : inputValidate.isValid,
          },
        }));
      }
    }else{
      setPersonalInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.value === '' ? true : inputValidate.isValid,
        },
      }));
    }
  };

  wizardValidation.formValidation.isValidate = personalInfoValidation;

  const onClickVerifyAddress = (name = "") => {
    if (name == "guardian") {
      const validateAddress =
        personalInfo.guardianAddressLine1.value != "" &&
        personalInfo.guardianCity.value != "" &&
        personalInfo.guardianState.value != "" &&
        personalInfo.guardianZipcode.value != "" &&
        personalInfo.guardianAddressLine1.isValid &&
        personalInfo.guardianAddressLine2.isValid &&
        personalInfo.guardianCity.isValid &&
        personalInfo.guardianState.isValid &&
        personalInfo.guardianZipcode.isValid;
      setPersonalInfo((prevState) => ({
        ...prevState,
        isGuardianAddressVerified: validateAddress,
      }));

      if (validateAddress) {
        const address = {
          addressLine1: personalInfo.guardianAddressLine1.value,
          addressLine2: personalInfo.guardianAddressLine2.value,
          city: personalInfo.guardianCity.value,
          state: personalInfo.guardianState.value,
          zipCode: personalInfo.guardianZipcode.value,
        };
        setPersonalInfo((prevState) => ({
          ...prevState,
          guardianAddressLine1: { value: personalInfo.guardianAddressLine1.value, isValid: true },
          guardianAddressLine2: { value: personalInfo.guardianAddressLine2.value, isValid: true },
          guardianCity: { value: personalInfo.guardianCity.value, isValid: true },
          guardianState: { value: personalInfo.guardianState.value, isValid: true },
          guardianZipcode: { value: personalInfo.guardianZipcode.value, isValid: true },
        }))
        dispatch(
          smartyStreetApi({
            address,
            callbackVerifiedAddress,
            name: "guardian",
          })
        );
      } else {
        toast.error(errorMessage.mandatoryFieldsToastErrorMessage);
        setPersonalInfo((prevState) => ({
          ...prevState,
          guardianAddressLine1: {
            value: prevState.guardianAddressLine1.value,
            isValid:
              prevState.guardianAddressLine1.isValid &&
              prevState.guardianAddressLine1.value != "",
          },
          guardianAddressLine2: {
            value: prevState.guardianAddressLine2.value,
            isValid: prevState.guardianAddressLine2.isValid,
          },
          guardianCity: {
            value: prevState.guardianCity.value,
            isValid:
              prevState.guardianCity.isValid &&
              prevState.guardianCity.value != "",
          },
          guardianState: {
            value: prevState.guardianState.value,
            isValid:
              prevState.guardianState.isValid &&
              prevState.guardianState.value != "",
          },
          guardianZipcode: {
            value: prevState.guardianZipcode.value,
            isValid:
              prevState.guardianZipcode.isValid &&
              prevState.guardianZipcode.value != "",
          },
        }));
      }
    }else if (name == "payableAddress") {
      const validateAddress =
        personalInfo.PayableAddressLine1.value != "" &&
        personalInfo.PayableCity.value != "" &&
        personalInfo.PayableState.value != "" &&
        personalInfo.PayableZipCode.value != "" &&
        personalInfo.PayableAddressLine1.isValid &&
        personalInfo.PayableCity.isValid &&
        personalInfo.PayableState.isValid &&
        personalInfo.PayableZipCode.isValid;
      setPersonalInfo((prevState) => ({
        ...prevState,
        isPayableAddressVerified: validateAddress,
      }));

      if (validateAddress) {
        const address = {
          addressLine1: personalInfo.PayableAddressLine1.value,
          addressLine2: personalInfo.PayableAddressLine2.value,
          city: personalInfo.PayableCity.value,
          state: personalInfo.PayableState.value,
          zipCode: personalInfo.PayableZipCode.value,
        };
        setPersonalInfo((prevState) => ({
          ...prevState,
          PayableAddressLine1: { value: personalInfo.PayableAddressLine1.value, isValid: true },
          PayableAddressLine2: { value: personalInfo.PayableAddressLine2.value, isValid: true },
          PayableCity: { value: personalInfo.PayableCity.value, isValid: true },
          PayableState: { value: personalInfo.PayableState.value, isValid: true },
          PayableZipCode: { value: personalInfo.PayableZipCode.value, isValid: true },
        }))
        dispatch(
          smartyStreetApi({
            address,
            callbackVerifiedAddress,
            name: "payableAddress",
          })
        );
      } else {
        toast.error(errorMessage.mandatoryFieldsToastErrorMessage);
        setPersonalInfo((prevState) => ({
          ...prevState,
          PayableAddressLine1: {
            value: prevState.PayableAddressLine1.value,
            isValid:
              prevState.PayableAddressLine1.isValid &&
              prevState.PayableAddressLine1.value != "",
          },
          PayableAddressLine2: {
            value: prevState.PayableAddressLine2.value,
            isValid: prevState.PayableAddressLine2.isValid,
          },
          PayableCity: {
            value: prevState.PayableCity.value,
            isValid:
              prevState.PayableCity.isValid &&
              prevState.PayableCity.value != "",
          },
          PayableState: {
            value: prevState.PayableState.value,
            isValid:
              prevState.PayableState.isValid &&
              prevState.PayableState.value != "",
          },
          PayableZipCode: {
            value: prevState.PayableZipCode.value,
            isValid:
              prevState.PayableZipCode.isValid &&
              prevState.PayableZipCode.value != "",
          },
        }));
      }
    }
     else {
      const validateAddress =
        personalInfo.healthCareAddressLine1.value != "" &&
        personalInfo.healthCareCity.value != "" &&
        personalInfo.healthCareState.value != "" &&
        personalInfo.healthCareZipcode.value != "" &&
        personalInfo.healthCareAddressLine1.isValid &&
        personalInfo.healthCareAddressLine2.isValid &&
        personalInfo.healthCareCity.isValid &&
        personalInfo.healthCareState.isValid &&
        personalInfo.healthCareZipcode.isValid;
      setPersonalInfo((prevState) => ({
        ...prevState,
        isHealthCareAddressVerified: validateAddress,
      }));
      if (validateAddress) {
        const address = {
          addressLine1: personalInfo.healthCareAddressLine1.value,
          addressLine2: personalInfo.healthCareAddressLine2.value,
          city: personalInfo.healthCareCity.value,
          state: personalInfo.healthCareState.value,
          zipCode: personalInfo.healthCareZipcode.value,
        };
        setPersonalInfo((prevState) => ({
          ...prevState,
          healthCareAddressLine1: { value: personalInfo.healthCareAddressLine1.value, isValid: true },
          healthCareAddressLine2: { value: personalInfo.healthCareAddressLine2.value, isValid: true },
          healthCareCity: { value: personalInfo.healthCareCity.value, isValid: true },
          healthCareState: { value: personalInfo.healthCareState.value, isValid: true },
          healthCareZipcode: { value: personalInfo.healthCareZipcode.value, isValid: true },
        }))
        dispatch(smartyStreetApi({ address, callbackVerifiedAddress, name }));
      } else {
        toast.error(errorMessage.mandatoryFieldsToastErrorMessage);
        setPersonalInfo((prevState) => ({
          ...prevState,
          healthCareAddressLine1: {
            value: prevState.healthCareAddressLine1.value,
            isValid:
              prevState.healthCareAddressLine1.isValid &&
              prevState.healthCareAddressLine1.value != "",
          },
          healthCareAddressLine2: {
            value: prevState.healthCareAddressLine2.value,
            isValid: prevState.healthCareAddressLine2.isValid,
          },
          healthCareCity: {
            value: prevState.healthCareCity.value,
            isValid:
              prevState.healthCareCity.isValid &&
              prevState.healthCareCity.value != "",
          },
          healthCareState: {
            value: prevState.healthCareState.value,
            isValid:
              prevState.healthCareState.isValid &&
              prevState.healthCareState.value != "",
          },
          healthCareZipcode: {
            value: prevState.healthCareZipcode.value,
            isValid:
              prevState.healthCareZipcode.isValid &&
              prevState.healthCareZipcode.value != "",
          },
        }));
      }
    }

  };

  const callbackVerifiedAddress = (address, name) => {
    if (
      address?.isValidateAddress != undefined &&
      address.isValidateAddress == "ExactMatch"
    ) {
      if (name == "payableAddress") {
        setPersonalInfo((prevState) => ({
          ...prevState,
          PayableAddressLine1: {
            value: address.street,
            isValid: prevState.PayableAddressLine1.isValid,
          },
          PayableAddressLine2: {
            value: address.street2,
            isValid: prevState.PayableAddressLine2.isValid,
          },
          PayableCity: {
            value: address.city,
            isValid: prevState.PayableCity.isValid,
          },
          PayableState: {
            value: address.state,
            isValid: prevState.PayableState.isValid,
          },
          PayableZipCode: {
            value: address.zipcode,
            isValid: prevState.PayableZipCode.isValid,
          },
          payable: {
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_success",
            ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
            isVerified: true,
          },
        }));
      }
      if (name == "guardian") {
        setPersonalInfo((prevState) => ({
          ...prevState,
          guardianAddressLine1: {
            value: address.street,
            isValid: prevState.guardianAddressLine1.isValid,
          },
          guardianAddressLine2: {
            value: address.street2,
            isValid: prevState.guardianAddressLine2.isValid,
          },
          guardianCity: {
            value: address.city,
            isValid: prevState.guardianCity.isValid,
          },
          guardianState: {
            value: address.state,
            isValid: prevState.guardianState.isValid,
          },
          guardianZipcode: {
            value: address.zipcode,
            isValid: prevState.guardianZipcode.isValid,
          },
          guardian: {
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_success",
            ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
            isVerified: true,
          },
        }));
      } else {
        setPersonalInfo((prevState) => ({
          ...prevState,
          healthCareAddressLine1: {
            value: address.street,
            isValid: prevState.healthCareAddressLine1.isValid,
          },
          healthCareAddressLine2: {
            value: address.street2,
            isValid: prevState.healthCareAddressLine2.isValid,
          },
          healthCareCity: {
            value: address.city,
            isValid: prevState.healthCareCity.isValid,
          },
          healthCareState: {
            value: address.state,
            isValid: prevState.healthCareState.isValid,
          },
          healthCareZipcode: {
            value: address.zipcode,
            isValid: prevState.healthCareZipcode.isValid,
          },
          healthCare: {
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_success",
            ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
            isVerified: true,
          },
        }));
      }
    } else {
      if (name == "payableAddress") {
        setPersonalInfo((prevState) => ({
          ...prevState,
          PayableAddressLine1: {
            value: address.street,
            isValid: prevState.PayableAddressLine1.isValid,
          },
          PayableAddressLine2: {
            value: address.street2,
            isValid: prevState.PayableAddressLine2.isValid,
          },
          PayableCity: {
            value: address.city,
            isValid: prevState.PayableCity.isValid,
          },
          PayableState: {
            value: address.state,
            isValid: prevState.PayableState.isValid,
          },
          PayableZipCode: {
            value: address.zipcode,
            isValid: prevState.PayableZipCode.isValid,
          },
          payable: {
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_error",
            ss_msg: errorMessage.smartyStreetMsg.errorMsg,
            isVerified: true,
          },
        }));
      }
      if (name == "guardian") {
        setPersonalInfo((prevState) => ({
          ...prevState,
          guardianAddressLine1: {
            value: address.street,
            isValid: prevState.guardianAddressLine1.isValid,
          },
          guardianAddressLine2: {
            value: address.street2,
            isValid: prevState.guardianAddressLine2.isValid,
          },
          guardianCity: {
            value: address.city,
            isValid: prevState.guardianCity.isValid,
          },
          guardianState: {
            value: address.state,
            isValid: prevState.guardianState.isValid,
          },
          guardianZipcode: {
            value: address.zipcode,
            isValid: prevState.guardianZipcode.isValid,
          },
          guardian: {
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_error",
            ss_msg: errorMessage.smartyStreetMsg.errorMsg,
            isVerified: true,
          },
        }));
      } else {
        setPersonalInfo((prevState) => ({
          ...prevState,
          healthCareAddressLine1: {
            value: address.street,
            isValid: prevState.healthCareAddressLine1.isValid,
          },
          healthCareAddressLine2: {
            value: address.street2,
            isValid: prevState.healthCareAddressLine2.isValid,
          },
          healthCareCity: {
            value: address.city,
            isValid: prevState.healthCareCity.isValid,
          },
          healthCareState: {
            value: address.state,
            isValid: prevState.healthCareState.isValid,
          },
          healthCareZipcode: {
            value: address.zipcode,
            isValid: prevState.healthCareZipcode.isValid,
          },
          healthCare: {
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_error",
            ss_msg: errorMessage.smartyStreetMsg.errorMsg,
            isVerified: true,
          },
        }));
      }
    }
  };

  return (
    <React.Fragment>
      <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="home"></i>
          <p className="p-1 ps-3 text-theme-1">
            {" "}
            {selectedLanguage.addressInformation.heading}{" "}
          </p>
        </div>
        <Input
          type="text"
          id="addressType"
          label={selectedLanguage.addressInformation.addressType}
          name="addressType"
          value={personalInfo.addressType.value}
          isValid={personalInfo.addressType.isValid}
          onChange={(e) => inputOnChange(e, "address")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
          maxLength="100"
        />
        <Input
          type="text"
          id="addressLine1"
          label={selectedLanguage.addressInformation.addressLine1}
          name="addressLine1"
          value={personalInfo.addressLine1.value}
          isValid={personalInfo.addressLine1.isValid}
          onChange={(e) => inputOnChange(e, "address")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
        />
        <Input
          type="text"
          id="addressLine2"
          label={selectedLanguage.addressInformation.addressLine2}
          name="addressLine2"
          value={personalInfo.addressLine2.value}
          isValid={personalInfo.addressLine2.isValid}
          onChange={(e) => inputOnChange(e, "addressLine2")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
          maxLength="100"
        />
        <Input
          type="text"
          id="city"
          label={selectedLanguage.addressInformation.city}
          name="city"
          value={personalInfo.city.value}
          isValid={personalInfo.city.isValid}
          onChange={(e) => inputOnChange(e, "city")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
        />
        <Input
          type="text"
          id="state"
          label={selectedLanguage.addressInformation.state}
          name="state"
          value={personalInfo.state.value}
          isValid={personalInfo.state.isValid}
          onChange={(e) => inputOnChange(e, "state")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
          maxLength="100"
        />
        <Input
          type="text"
          id="zipcode"
          label={selectedLanguage.addressInformation.zipcode}
          name="zipcode"
          value={personalInfo.zipcode.value}
          isValid={personalInfo.zipcode.isValid}
          onChange={(e) => inputOnChange(e, "zipcode")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
        />
      </div>
      <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="phone"></i>
          <p className="p-1 ps-3 text-theme-1">
            {" "}
            {selectedLanguage.contactDetails.heading}
          </p>
        </div>
        <div className="intro-y g-col-5 g-col-sm-7 g-col-xl-8 py-8 px-8" style={{textAlign: "left"}}>
          <p>{selectedLanguage.contactDetails.contactBy}</p>
        </div>
        <div className="intro-y g-col-7 g-col-md-5 g-col-xl-4 px-8">
        <Input
            type="select_contact"
            id="contactby"
            label="Preferred Contact Method"
            name="contactby"
            value={personalInfo.contactby.value}
            isValid={personalInfo.contactby.isValid}
            onChange={(e) => inputOnChange(e, "dropDown")}
            errorMsg={errorMessage?.inputErrorMessage}
            className="fs-xs"
            maxLength="100"
            elmentconfig={lookUpData.methodOfContact}
          />
          </div>
        {/* <div className="intro-y g-col-12 g-col-md-12 g-col-xl-12">
          <Input
            type="select"
            id="contactby"
            label={selectedLanguage.contactDetails.contactBy}
            name="contactby"
            value={personalInfo.contactby.value}
            isValid={personalInfo.contactby.isValid}
            onChange={(e) => inputOnChange(e, "dropDown")}
            errorMsg={errorMessage?.inputErrorMessage}
            className="fs-xs"
            maxLength="100"
            elmentconfig={lookUpData.methodOfContact}
          />
        </div> */}
        <Input
          type="select"
          id="preferedLanguage"
          label={selectedLanguage.contactDetails.preferedLanguage}
          name="preferedLanguage"
          value={personalInfo.preferedLanguage.value}
          isValid={personalInfo.preferedLanguage.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.preferredLanguage}
        />
        <Input
          type="text"
          id="email"
          label={selectedLanguage.contactDetails.email}
          name="email"
          value={personalInfo.email.value}
          isValid={personalInfo.email.isValid}
          onChange={(e) => inputOnChange(e, "email")}
          maxLength="100"
          errorMsg={errorMessage?.inputErrorMessage}
        />
        <Input
          type="select"
          id="emailType"
          label={selectedLanguage.contactDetails.emailType}
          name="emailType"
          value={personalInfo.emailType.value}
          isValid={personalInfo.emailType.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.emailType}
        />
        <Input
          type="select"
          id="emailOwner"
          label={selectedLanguage.contactDetails.emailOwner}
          name="emailOwner"
          value={personalInfo.emailOwner.value}
          isValid={personalInfo.emailOwner.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.emailOwner}
        />
        <Input
          type="select"
          id="phoneType"
          label={selectedLanguage.contactDetails.phoneType}
          name="phoneType"
          value={personalInfo.phoneType.value}
          isValid={personalInfo.phoneType.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.phoneType}
        />
        <Input
          type="text"
          id="phoneNumber"
          label={selectedLanguage.contactDetails.phoneNumber}
          name="phoneNumber"
          value={personalInfo.phoneNumber.value}
          isValid={personalInfo.phoneNumber.isValid}
          onChange={(e) => inputOnChange(e, "phoneNumber")}
          maxLength="12"
          errorMsg={personalInfo.phoneNumber.errorMsg ? "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
        />
        {patientInformation.Program == "FAF" && <Input
          type="select"
          id="contactSequence"
          label={selectedLanguage.contactDetails.contactSequence}
          name="contactSequence"
          value={personalInfo.contactSequence.value}
          isValid={personalInfo.contactSequence.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.contactSequence}
        />}
      </div>
      {personalInfo.hasGuardian && (
        <React.Fragment>
          <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
            <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
              <i data-feather="phone"></i>
              <p className="p-1 ps-3 text-theme-1">
                {selectedLanguage.guardianInfo.heading}
              </p>
            </div>
            <Input
              type="text"
              id="guardianFirstName"
              label={selectedLanguage.guardianInfo.guardianFirstName}
              name="guardianFirstName"
              value={personalInfo.guardianFirstName.value}
              isValid={personalInfo.guardianFirstName.isValid}
              onChange={(e) => inputOnChange(e, "name")}
              maxLength="30"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="guardianLastName"
              label={selectedLanguage.guardianInfo.guardianLastName}
              name="guardianLastName"
              value={personalInfo.guardianLastName.value}
              isValid={personalInfo.guardianLastName.isValid}
              onChange={(e) => inputOnChange(e, "name")}
              maxLength="30"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="select"
              id="guardianSuffix"
              label={selectedLanguage.guardianInfo.suffix}
              name="guardianSuffix"
              value={personalInfo.guardianSuffix.value}
              isValid={personalInfo.guardianSuffix.isValid}
              onChange={(e) => inputOnChange(e, "dropDown")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
              elmentconfig={lookUpData.suffix}
            />
            <DateInput
              id="guardianDOB"
              name="guardianDOB"
              label={selectedLanguage.guardianInfo.guardianDOB}
              value={personalInfo.guardianDOB.value}
              isValid={personalInfo.guardianDOB.isValid}
              errorMsg={errorMessage.inputErrorMessage}
              onChange={(e) => inputOnChange(e, "guardianDOB")}
            />
            <Input
              type="text"
              id="guardianSSN"
              label={selectedLanguage.guardianInfo.guardianSSN}
              name="guardianSSN"
              value={personalInfo.guardianSSN.value}
              isValid={personalInfo.guardianSSN.isValid}
              onChange={(e) => inputOnChange(e, "ssn")}
              maxLength="11"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="guardianAlien"
              label={selectedLanguage.guardianInfo.guardianAlien}
              name="guardianAlien"
              value={personalInfo.guardianAlien.value}
              isValid={personalInfo.guardianAlien.isValid}
              onChange={(e) => inputOnChange(e, "alienNumber")}
              maxLength="10"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="select"
              id="guardianRelationshipToPatient"
              label={selectedLanguage.guardianInfo.relationshipToPatient}
              name="guardianRelationshipToPatient"
              value={personalInfo.guardianRelationshipToPatient.value}
              isValid={personalInfo.guardianRelationshipToPatient.isValid}
              onChange={(e) => inputOnChange(e, "dropDown")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
              elmentconfig={lookUpData.relationshipToPatient}
            />
            <Input
              type="select"
              id="guardianEmployment"
              label={selectedLanguage.guardianInfo.guardianEmployment}
              name="guardianEmployment"
              value={personalInfo.guardianEmployment.value}
              isValid={personalInfo.guardianEmployment.isValid}
              onChange={(e) => inputOnChange(e, "dropDown")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
              elmentconfig={lookUpData.employementStatus}
            />
            <Input
              type="text"
              id="guardianEmail"
              label={selectedLanguage.guardianInfo.guardianEmail}
              name="guardianEmail"
              value={personalInfo.guardianEmail.value}
              isValid={personalInfo.guardianEmail.isValid}
              onChange={(e) => inputOnChange(e, "email")}
              maxLength="100"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="select"
              id="guardianEmailType"
              label={selectedLanguage.guardianInfo.emailType}
              name="guardianEmailType"
              value={personalInfo.guardianEmailType.value}
              isValid={personalInfo.guardianEmailType.isValid}
              onChange={(e) => inputOnChange(e, "dropDown")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
              elmentconfig={lookUpData.emailType}
            />
          </div>
          <div className="row mt-5 p-8 mb-5">
            <Input
              type="switch2"
              id="isAddressChecked"
              name="isAddressChecked"
              label={selectedLanguage.guardianInfo.sameAddress}
              value={personalInfo.isAddressChecked}
              onClick={inputOnChange}
            />
            <Input
              type="switch2"
              id="isPhoneNumberChecked"
              name="isPhoneNumberChecked"
              label={selectedLanguage.guardianInfo.samePhoneNumber}
              value={personalInfo.isPhoneNumberChecked}
              onClick={inputOnChange}
            />
          </div>
          {/* if the Address toggle is falses */}
          {!personalInfo.isAddressChecked && (
            <>
              <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-1">
                <Input
                  type="text"
                  id="guardianAddressLine1"
                  label={selectedLanguage.guardianInfo.addressLine1}
                  name="guardianAddressLine1"
                  value={personalInfo.guardianAddressLine1.value}
                  isValid={personalInfo.guardianAddressLine1.isValid}
                  onChange={(e) => inputOnChange(e, "address")}
                  maxLength="100"
                  errorMsg={errorMessage?.inputErrorMessage}
                />
                <Input
                  type="text"
                  id="guardianAddressLine2"
                  label={selectedLanguage.guardianInfo.addressLine2}
                  name="guardianAddressLine2"
                  value={personalInfo.guardianAddressLine2.value}
                  isValid={personalInfo.guardianAddressLine2.isValid}
                  onChange={(e) => inputOnChange(e, "addressLine2")}
                  maxLength="100"
                  errorMsg={errorMessage?.inputErrorMessage}
                />
                <Input
                  type="text"
                  id="guardianCity"
                  label={selectedLanguage.guardianInfo.city}
                  name="guardianCity"
                  value={personalInfo.guardianCity.value}
                  isValid={personalInfo.guardianCity.isValid}
                  onChange={(e) => inputOnChange(e, "city")}
                  maxLength="50"
                  errorMsg={errorMessage?.inputErrorMessage}
                />
                <Input
                  type="select"
                  id="guardianState"
                  label={selectedLanguage.guardianInfo.state}
                  name="guardianState"
                  value={personalInfo.guardianState.value}
                  isValid={personalInfo.guardianState.isValid}
                  onChange={(e) => inputOnChange(e, "state")}
                  errorMsg={errorMessage?.inputErrorMessage}
                  maxLength="100"
                  elmentconfig={lookUpData.State}
                />
                <Input
                  type="text"
                  id="guardianZipcode"
                  label={selectedLanguage.guardianInfo.zipcode}
                  name="guardianZipcode"
                  value={personalInfo.guardianZipcode.value}
                  isValid={personalInfo.guardianZipcode.isValid}
                  onChange={(e) => inputOnChange(e, "zipcode")}
                  maxLength="5"
                  errorMsg={errorMessage?.inputErrorMessage}
                />
              </div>
              <div
                className={`${personalInfo.guardian.ss_msg_cls} intro-y g-col-12 g-col-md-12 g-col-xl-12 mt-4 px-8`}
              >
                {personalInfo.guardian.ss_msg}
                <div className="px-8 mt-1">
                  <button
                    className="btn verifyAddres ms-2 z-10"
                    onClick={() => onClickVerifyAddress("guardian")}
                  >
                    {selectedLanguage.guardianInfo.verifyAddress}
                  </button>
                </div>
              </div>
            </>
          )}
          {/* if the Phone Number toggle is false */}
          {!personalInfo.isPhoneNumberChecked && (
            <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-1">
              <Input
                type="select"
                id="guardianPhoneType"
                label={selectedLanguage.guardianInfo.phoneType}
                name="guardianPhoneType"
                value={personalInfo.guardianPhoneType.value}
                isValid={personalInfo.guardianPhoneType.isValid}
                onChange={(e) => inputOnChange(e, "dropDown")}
                errorMsg={errorMessage?.inputErrorMessage}
                maxLength="100"
                elmentconfig={lookUpData.phoneType}
              />
              <Input
                type="text"
                id="guardianPhoneNumber"
                label={selectedLanguage.guardianInfo.phoneNumber}
                name="guardianPhoneNumber"
                value={personalInfo.guardianPhoneNumber.value}
                isValid={personalInfo.guardianPhoneNumber.isValid}
                onChange={(e) => inputOnChange(e, "phoneNumber")}
                maxLength="12"
                errorMsg={personalInfo.guardianPhoneNumber.errorMsg ? "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
              />
            </div>
          )}
        </React.Fragment>
      )}
      <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="credit-card"></i>
          <p className="p-1 ps-3 text-theme-1">
            {selectedLanguage.additionalInformation.heading}
          </p>
        </div>
        {appIntakeSteps.VerificationRequired == false && appIntakeSteps.DefaultPayee == "Other" ?<>
          <Input
          type="text"
          id="PayableToFirstName"
          label={"Award Payable To First Name"}
          name="PayableToFirstName"
          value={personalInfo.PayableToFirstName.value}
          isValid={personalInfo.PayableToFirstName.isValid}
          onChange={(e) => inputOnChange(e, "name")}
          maxLength="30"
          errorMsg={"Please select or input a valid value"}
        />
        <Input
          type="text"
          id="PayableToLastName"
          label={"Award Payable To Last Name"}
          name="PayableToLastName"
          value={personalInfo.PayableToLastName.value}
          isValid={personalInfo.PayableToLastName.isValid}
          onChange={(e) => inputOnChange(e, "name")}
          maxLength="30"
          errorMsg={"Please select or input a valid value"}
        />
        <Input
          type="text"
          id="PayableAddressLine1"
          label={"Address Line 1"}
          name="PayableAddressLine1"
          value={personalInfo.PayableAddressLine1.value}
          isValid={personalInfo.PayableAddressLine1.isValid}
          onChange={(e) => inputOnChange(e, "address")}
          maxLength="100"
          errorMsg={'Please select or input a valid value'}
        />
        <Input
          type="text"
          id="PayableAddressLine2"
          label={'Address Line 2'}
          name="PayableAddressLine2"
          value={personalInfo.PayableAddressLine2.value}
          isValid={personalInfo.PayableAddressLine2.isValid}
          onChange={(e) => inputOnChange(e, "addressLine2")}
          maxLength="100"
          errorMsg={'Please select or input a valid value'}
        />
         <Input
          type="text"
          id="PayableCity"
          label={'City'}
          name="PayableCity"
          value={personalInfo.PayableCity.value}
          isValid={personalInfo.PayableCity.isValid}
          onChange={(e) => inputOnChange(e, "city")}
          maxLength="50"
          errorMsg={'Please select or input a valid value'}
        />
        <Input
          type="select"
          id="PayableState"
          label={'State'}
          name="PayableState"
          value={personalInfo.PayableState.value}
          isValid={personalInfo.PayableState.isValid}
          onChange={(e) => inputOnChange(e, "state")}
          errorMsg={'Please select or input a valid value'}
          maxLength="100"
          elmentconfig={lookUpData.State}
        />
        <Input
          type="text"
          id="PayableZipCode"
          label={"Zip Code"}
          name="PayableZipCode"
          value={personalInfo.PayableZipCode.value}
          isValid={personalInfo.PayableZipCode.isValid}
          onChange={(e) => inputOnChange(e, "zipcode")}
          maxLength="5"
          errorMsg={'Please select or input a valid value'}
        />
        <div
          className={`${personalInfo.payable.ss_msg_cls} intro-y g-col-12 g-col-md-12 g-col-xl-12 mt-4 px-8`}
        >
          {personalInfo.payable.ss_msg}
          <div className="px-8 mt-1">
            <button
              className="btn verifyAddres ms-2 z-10"
              onClick={() => onClickVerifyAddress("payableAddress")}
            >
               Verify Address
            </button>
          </div>
        </div>
        </>:null}
        
        <Input
          type="select"
          id="gender"
          label={selectedLanguage.additionalInformation.gender}
          name="gender"
          value={personalInfo.gender.value}
          isValid={personalInfo.gender.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.gender}
        />
        <Input
          type="select"
          id="employementStatus"
          label={selectedLanguage.additionalInformation.employementStatus}
          name="employementStatus"
          value={personalInfo.employementStatus.value}
          isValid={personalInfo.employementStatus.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.employementStatus}
        />
        <Input
          type="select"
          id="veteran"
          label={selectedLanguage.additionalInformation.veteran}
          name="veteran"
          value={personalInfo.veteran.value}
          isValid={personalInfo.veteran.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.veteranAndHispanic}
        />
        <Input
          type="select"
          id="maritalStatus"
          label={selectedLanguage.additionalInformation.maritalStatus}
          name="maritalStatus"
          value={personalInfo.maritalStatus.value}
          isValid={personalInfo.maritalStatus.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.maritalStatus}
        />
        <Input
          type="select"
          id="householdSize"
          label={selectedLanguage.additionalInformation.householdSize}
          name="householdSize"
          value={personalInfo.householdSize.value}
          isValid={personalInfo.householdSize.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.houseHoldSize}
        />
      </div>
      <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right">
        <p className={`p-1 ps-10 ${!raceValidation ? "color-danger" : ""}`}>
          {selectedLanguage.race.heading}
        </p>
      </div>
      <div className="grid columns-12 gap-4 gap-y-5 px-8 mb-5">
        {personalInfo.race.map((race, index) => {
          return (
            <div className="intro-y g-col-12 g-col-sm-4 text-start">
              <input
                className="form-check-input"
                value={race.value}
                name={"race"}
                type="checkbox"
                checked={race.isChecked}
                onChange={(e) => inputOnChange(e, "", index)}
              />
              <label className="form-check-label">{race.value}</label>
            </div>
          );
        })}
        {!raceValidation && (
          <p className="color-danger g-col-12 g-col-sm-12 text-start">
            Please select atleast 1 race
          </p>
        )}
      </div>
      <div className="grid columns-12 gap-4 gap-y-5 ps-16">
        {personalInfo.race.map((other) => {
          return (
            other.value == "Other" &&
            other.isChecked && (
              <Input
                type="text"
                id="raceOther"
                label={selectedLanguage.race.otherSpecify}
                name="raceOther"
                value={personalInfo.raceOther.value}
                isValid={personalInfo.raceOther.isValid}
                onChange={(e) => inputOnChange(e, "address")}
                maxLength="100"
                errorMsg={errorMessage?.inputErrorMessage}
              />
            )
          );
        })}
        <div className="intro-y g-col-4 g-col-md-5 g-col-xl-5">
          <Input
            type="select"
            id="origin"
            label={selectedLanguage.race.Origin}
            name="origin"
            value={personalInfo.origin.value}
            isValid={personalInfo.origin.isValid}
            onChange={(e) => inputOnChange(e, "dropDown")}
            errorMsg={errorMessage?.inputErrorMessage}
            maxLength="100"
            elmentconfig={lookUpData.veteranAndHispanic}
          />
        </div>
        {patientInformation.Program == "CPR" && preQualData.fundGroup != "Travel" && (
          <div className="intro-y g-col-4 g-col-md-5 g-col-xl-5">
            <Input
              type="switch"
              id="copayProgramsCheck"
              name="copayProgramsCheck"
              label={"Do you receive assistance from other Co-Pay Programs?"}
              value={personalInfo.copayPrograms.isChecked}
              labelPosition="left"
              onClick={inputOnChange}
            />
          </div>
        )}
        {personalInfo.copayPrograms.isChecked && (
          <div className="intro-y g-col-4 g-col-md-5 g-col-xl-5">
            <Input
              type="select"
              id="copayPrograms"
              label={"Which Program"}
              name="copayPrograms"
              value={personalInfo.copayPrograms.value}
              isValid={personalInfo.copayPrograms.isValid}
              onChange={(e) => inputOnChange(e, "dropDown")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
              elmentconfig={lookUpData.CoPayPrograms}
            />
          </div>
        )}
      </div>
      <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="file-text"></i>
          <p className="p-1 ps-3 text-theme-1">
            {" "}
            {selectedLanguage.applicantInformation.heading}{" "}
          </p>
        </div>
        <Input
          type="select"
          id="relationshipToPatient"
          label={selectedLanguage.applicantInformation.relationshipToPatient}
          name="relationshipToPatient"
          value={personalInfo.relationshipToPatient.value}
          isValid={personalInfo.relationshipToPatient.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.applicantIs}
        />
        {personalInfo.relationshipToPatient.value != "" &&
          personalInfo.relationshipToPatient.value != "Self" && (
            <React.Fragment>
              <Input
                type="text"
                id="applicantFirstName"
                label={selectedLanguage.applicantInformation.firstName}
                name="applicantFirstName"
                value={personalInfo.applicantFirstName.value}
                isValid={personalInfo.applicantFirstName.isValid}
                onChange={(e) => inputOnChange(e, "name")}
                maxLength="30"
                errorMsg={errorMessage?.inputErrorMessage}
              />
              <Input
                type="text"
                id="applicantLastName"
                label={selectedLanguage.applicantInformation.lastName}
                name="applicantLastName"
                value={personalInfo.applicantLastName.value}
                isValid={personalInfo.applicantLastName.isValid}
                onChange={(e) => inputOnChange(e, "name")}
                maxLength="30"
                errorMsg={errorMessage?.inputErrorMessage}
              />
              <Input
                type="text"
                id="applicantPhoneNumber"
                label={selectedLanguage.applicantInformation.phoneNumber}
                name="applicantPhoneNumber"
                value={personalInfo.applicantPhoneNumber.value}
                isValid={personalInfo.applicantPhoneNumber.isValid}
                onChange={(e) => inputOnChange(e, "phoneNumber")}
                maxLength="12"
                errorMsg={personalInfo.applicantPhoneNumber.errorMsg ? "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
              />
            </React.Fragment>
          )}
      </div>
      <div className="grid columns-12 gap-4 gap-y-5 mt-4 p-4">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5">
          <i data-feather="users"></i>
          <p className="p-1 ps-3 text-theme-1">
            {" "}
            {selectedLanguage.referalInformation.heading}{" "}
          </p>
        </div>
        <div className="intro-y g-col-12 g-col-sm-8 py-8">
          <p>{selectedLanguage.referalInformation.referredBy}</p>
        </div>
        <Input
          type="select"
          id="referredBy"
          label="Program"
          name="referredBy"
          value={personalInfo.referredBy.value}
          isValid={personalInfo.referredBy.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.referredSource}
        />
      </div>
      {personalInfo.referredBy.value == "Other/Unknown" && (
        <div className="grid columns-12 gap-4 gap-y-5">
          <Input
            type="text"
            id="referredOther"
            label={selectedLanguage.race.otherSpecify}
            name="referredOther"
            value={personalInfo.referredOther.value}
            isValid={personalInfo.referredOther.isValid}
            onChange={(e) => inputOnChange(e, "otherRef")}
            maxLength="100"
            errorMsg={errorMessage?.inputErrorMessage}
          />
        </div>
      )}
      {personalInfo.referredBy.value == "Healthcare Professional" && (
        <React.Fragment>
          <Input
            type="switch1"
            id="sameAsHealthCare"
            labelPosition="left"
            name="sameAsHealthCare"
            label={selectedLanguage.healthCare.sameAsSwitch}
            value={personalInfo.sameAsHealthCare}
            onClick={inputOnChange}
          />
          <div className="grid columns-12 gap-4 gap-y-5 mt-5 pt-3">
            <Input
              type="text"
              id="healthCareProfessionalFirstName"
              label={selectedLanguage.healthCare.firstName}
              name="healthCareProfessionalFirstName"
              value={
                personalInfo.sameAsHealthCare
                  ? personalInfo.applicantFirstName.value
                  : personalInfo.healthCareProfessionalFirstName.value
              }
              isValid={personalInfo.healthCareProfessionalFirstName.isValid}
              onChange={(e) => inputOnChange(e, "name")}
              maxLength="30"
              errorMsg={errorMessage?.inputErrorMessage}
              disabled={personalInfo.sameAsHealthCare}
            />
            <Input
              type="text"
              id="healthCareProfessionalLastName"
              label={selectedLanguage.healthCare.lastName}
              name="healthCareProfessionalLastName"
              value={
                personalInfo.sameAsHealthCare
                  ? personalInfo.applicantLastName.value
                  : personalInfo.healthCareProfessionalLastName.value
              }
              isValid={personalInfo.healthCareProfessionalLastName.isValid}
              onChange={(e) => inputOnChange(e, "name")}
              maxLength="30"
              errorMsg={errorMessage?.inputErrorMessage}
              disabled={personalInfo.sameAsHealthCare}
            />
            <Input
              type="text"
              id="healthCareProfessionalFacilityName"
              label={selectedLanguage.healthCare.facilityPractice}
              name="healthCareProfessionalFacilityName"
              value={personalInfo.healthCareProfessionalFacilityName.value}
              isValid={personalInfo.healthCareProfessionalFacilityName.isValid}
              onChange={(e) => inputOnChange(e, "address")}
              maxLength="200"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="healthCareProfessionalPosition"
              label={selectedLanguage.healthCare.position}
              name="healthCareProfessionalPosition"
              value={personalInfo.healthCareProfessionalPosition.value}
              isValid={personalInfo.healthCareProfessionalPosition.isValid}
              onChange={(e) => inputOnChange(e, "address")}
              maxLength="100"
              errorMsg={errorMessage?.inputErrorMessage}
            />
          </div>
        </React.Fragment>
      )}
      {(personalInfo.referredBy.value == "Healthcare Professional" ||
        personalInfo.referredBy.value == "Healthcare Facility") && (
          <div className="grid columns-12 gap-4 gap-y-5 mt-3">
            {personalInfo.referredBy.value == "Healthcare Facility" && (
              <Input
                type="text"
                id="healthCareFacilityName"
                label={selectedLanguage.healthCare.facilityName}
                name="healthCareFacilityName"
                value={personalInfo.healthCareFacilityName.value}
                isValid={personalInfo.healthCareFacilityName.isValid}
                onChange={(e) => inputOnChange(e, "address")}
                maxLength="200"
                errorMsg={errorMessage?.inputErrorMessage}
              />
            )}
            <Input
              type="text"
              id="healthCareAddressLine1"
              label={selectedLanguage.healthCare.addressLine1}
              name="healthCareAddressLine1"
              value={personalInfo.healthCareAddressLine1.value}
              isValid={personalInfo.healthCareAddressLine1.isValid}
              onChange={(e) => inputOnChange(e, "address")}
              maxLength="100"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="healthCareAddressLine2"
              label={selectedLanguage.healthCare.addressLine2}
              name="healthCareAddressLine2"
              value={personalInfo.healthCareAddressLine2.value}
              isValid={personalInfo.healthCareAddressLine2.isValid}
              onChange={(e) => inputOnChange(e, "addressLine2")}
              maxLength="100"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="healthCareCity"
              label={selectedLanguage.healthCare.city}
              name="healthCareCity"
              value={personalInfo.healthCareCity.value}
              isValid={personalInfo.healthCareCity.isValid}
              onChange={(e) => inputOnChange(e, "city")}
              maxLength="50"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="select"
              id="healthCareState"
              label={selectedLanguage.healthCare.state}
              name="healthCareState"
              value={personalInfo.healthCareState.value}
              isValid={personalInfo.healthCareState.isValid}
              onChange={(e) => inputOnChange(e, "state")}
              errorMsg={errorMessage?.inputErrorMessage}
              maxLength="100"
              elmentconfig={lookUpData.State}
            />
            <Input
              type="text"
              id="healthCareZipcode"
              label={selectedLanguage.healthCare.zipcode}
              name="healthCareZipcode"
              value={personalInfo.healthCareZipcode.value}
              isValid={personalInfo.healthCareZipcode.isValid}
              onChange={(e) => inputOnChange(e, "zipcode")}
              maxLength="5"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="healthCarePhoneNumber"
              label={selectedLanguage.healthCare.phoneNumber}
              name="healthCarePhoneNumber"
              value={
                (personalInfo.referredBy.value == "Healthcare Professional" &&
                  personalInfo.sameAsHealthCare)
                  ? personalInfo.applicantPhoneNumber.value
                  : personalInfo.healthCarePhoneNumber.value
              }
              isValid={personalInfo.healthCarePhoneNumber.isValid}
              onChange={(e) => inputOnChange(e, "phoneNumber")}
              maxLength="12"
              errorMsg={personalInfo.healthCarePhoneNumber.errorMsg ? "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
            />
            <Input
              type="text"
              id="healthCareEmail"
              label={selectedLanguage.healthCare.email}
              name="healthCareEmail"
              value={personalInfo.healthCareEmail.value}
              isValid={personalInfo.healthCareEmail.isValid}
              onChange={(e) => inputOnChange(e, "email")}
              maxLength="100"
              errorMsg={errorMessage?.inputErrorMessage}
            />
            {personalInfo.healthCareEmail.value != "" &&
              personalInfo.healthCareEmail.isValid && (
                <Input
                  type="select"
                  id="healthCareEmailType"
                  label={selectedLanguage.healthCare.emailType}
                  name="healthCareEmailType"
                  value={personalInfo.healthCareEmailType.value}
                  isValid={personalInfo.healthCareEmailType.isValid}
                  onChange={(e) => inputOnChange(e, "dropDown")}
                  errorMsg={errorMessage?.inputErrorMessage}
                  maxLength="100"
                  elmentconfig={lookUpData.emailType}
                />
              )}
          </div>
        )}
      {(personalInfo.referredBy.value == "Healthcare Professional" ||
        personalInfo.referredBy.value == "Healthcare Facility") && (
          <div
            className={`${personalInfo.healthCare.ss_msg_cls} intro-y g-col-12 g-col-md-12 g-col-xl-12 mt-4 px-8`}
          >
            {personalInfo.healthCare.ss_msg}
            <div className="px-8 mt-1">
              <button
                className="btn verifyAddres ms-2 z-10"
                onClick={onClickVerifyAddress}
              >
                {selectedLanguage.guardianInfo.verifyAddress}
              </button>
            </div>
          </div>
        )}
      {isEPaymentAvailable && (
        <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
          <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
            <i data-feather="home"></i>
            <p className="p-1 ps-3 text-theme-1">
              {selectedLanguage.ePayment.heading}
            </p>
          </div>
          <Input
            type="select"
            id="ePayment"
            label={selectedLanguage.ePayment.method}
            name="ePayment"
            value={personalInfo.ePayment.value}
            isValid={personalInfo.ePayment.isValid}
            onChange={(e) => inputOnChange(e, "dropDown")}
            errorMsg={errorMessage?.inputErrorMessage}
            elmentconfig={lookUpData.ePayment}
          />
        </div>
      )}
    </React.Fragment>
  );
}

export default PersonalInfo;
